module.exports = function getResource(label) {
    let resources = {
        yourColorIQMatch: 'Your Color iQ match.',
        edit: 'Edit',
        colorIQ: 'See your Color iQ match'
    };
    return resources[label];
};
